export const NAME_SPACE = 'ASSET_VIEW';

export const DETAILS_MODE = {
	panels: 'panels',
	fullwindow: 'fullwindow'
};

export const ASSET_PANELS = {
	details: 'Asset Details',
	history: 'Asset History',
	group:   'Asset Group',
	photos:  'Photos'
};

export const FILTER_ORDER = {
	numericAsc: 'numericAsc',
	numericDesc: 'numericDesc',
	alphaAsc: 'alphaAsc',
	alphaDesc: 'alphaDesc'
};

export const APPROVAL_MODE = {
	unapproved: 'u',
	approved: 'a',
	mixed: 'm'
};

export const MANAGER_LIST_PAGE = 200;
export const MANAGER_LIST_PAGING = 75;
export const MANAGER_PAGE_SIZES = [50, 100, 200, 500, 1000, 'All'];
// Elasticsearch's default max_result_window; pages beyond this cannot be fetched.
export const MANAGER_MAX_RESULT_WINDOW = 10000;
export const ASSET_LIST_PAGE_SIZE = 50;
export const ASSET_LIST_PAGE_SIZE_OPTIONS = [50, 100, 200, 500, 1000, 'all'];
export const ASSET_LIST_PAGINATION_STORAGE_KEY = 'cg_corrmonitor_pagination';
export const ASSET_VIEW_MAP_HEIGHT_OFFSET = 105;
export const ASSET_VIEW_LIST_HEIGHT_OFFSET = 157;
export const ASSET_VIEW_RESULTS_FOOTER_RESERVE = 96;
export const ASSET_VIEW_MIN_RESULTS_HEIGHT = 260;

export const getAssetViewResultsHeight = (windowHeight, baseOffset) => Math.max(
	ASSET_VIEW_MIN_RESULTS_HEIGHT,
	(Number(windowHeight) || 0) - baseOffset - ASSET_VIEW_RESULTS_FOOTER_RESERVE
);

const normalizeAssetListPageSize = value => {
	if (value === 'all') {return 'all';}
	const numericValue = Number(value);
	return ASSET_LIST_PAGE_SIZE_OPTIONS.includes(numericValue)
		? numericValue
		: ASSET_LIST_PAGE_SIZE;
};

const normalizeAssetListFrom = value => {
	const numericValue = Number(value);
	return Number.isFinite(numericValue) && numericValue >= 0
		? Math.floor(numericValue)
		: 0;
};

export const loadAssetListPaginationState = () => {
	try {
		const value = JSON.parse(localStorage.getItem(ASSET_LIST_PAGINATION_STORAGE_KEY) || '{}');
		return {
			listFrom:     normalizeAssetListFrom(value.listFrom),
			listPageSize: normalizeAssetListPageSize(value.listPageSize)
		};
	} catch {
		return {
			listFrom:     0,
			listPageSize: ASSET_LIST_PAGE_SIZE
		};
	}
};

export const persistAssetListPaginationState = ({ listFrom, listPageSize }) => {
	try {
		localStorage.setItem(ASSET_LIST_PAGINATION_STORAGE_KEY, JSON.stringify({
			listFrom:     normalizeAssetListFrom(listFrom),
			listPageSize: normalizeAssetListPageSize(listPageSize)
		}));
	} catch {
		// ignore
	}
};

export const DOWNLOADING_TEXT = 'Downloading...';
